import { render, staticRenderFns } from "./PageTitleArea.vue?vue&type=template&id=1ecab6ae&scoped=true&"
import script from "./PageTitleArea.vue?vue&type=script&lang=js&"
export * from "./PageTitleArea.vue?vue&type=script&lang=js&"
import style0 from "./PageTitleArea.vue?vue&type=style&index=0&id=1ecab6ae&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecab6ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ecab6ae')) {
      api.createRecord('1ecab6ae', component.options)
    } else {
      api.reload('1ecab6ae', component.options)
    }
    module.hot.accept("./PageTitleArea.vue?vue&type=template&id=1ecab6ae&scoped=true&", function () {
      api.rerender('1ecab6ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/PageTitleArea.vue"
export default component.exports